import { render, staticRenderFns } from "./TotalBlockRow.vue?vue&type=template&id=0a173e5c&scoped=true"
import script from "./TotalBlockRow.vue?vue&type=script&lang=js"
export * from "./TotalBlockRow.vue?vue&type=script&lang=js"
import style0 from "./TotalBlockRow.vue?vue&type=style&index=0&id=0a173e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a173e5c",
  null
  
)

export default component.exports